import React from 'react';

import {
  InputField,
  ListItem,
} from 'vindi-ds-components';

import templates from '../templates.json';

function CustomerStateField() {
  return (
    <InputField label='Estado' name='state' placeholder='' select>
      {Object.entries(templates.states).map(([code, name]) => (
        <ListItem value={code} key={code}>{name}</ListItem>
      ))}
    </InputField>
  );
}

export default CustomerStateField;
